import { render } from "./indetail.vue?vue&type=template&id=69885442&scoped=true"
import script from "./indetail.vue?vue&type=script&lang=js"
export * from "./indetail.vue?vue&type=script&lang=js"

import "./indetail.vue?vue&type=style&index=0&id=69885442&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69885442"]])

export default __exports__